import { render, staticRenderFns } from "./SelfieFace.vue?vue&type=template&id=3772471f"
import script from "./SelfieFace.vue?vue&type=script&lang=js"
export * from "./SelfieFace.vue?vue&type=script&lang=js"
import style0 from "./SelfieFace.vue?vue&type=style&index=0&id=3772471f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-life-proof-portal/hive-life-proof-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3772471f')) {
      api.createRecord('3772471f', component.options)
    } else {
      api.reload('3772471f', component.options)
    }
    module.hot.accept("./SelfieFace.vue?vue&type=template&id=3772471f", function () {
      api.rerender('3772471f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SelfieFace.vue"
export default component.exports